module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAwBAMAAAC/EAQ6AAAAG1BMVEW8vLwAAACNjY1GRkYXFxd1dXUvLy+kpKReXl5xYgjjAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAA5ElEQVQ4je2RsWrDMBRFT13L9ljZseOxSYdmtEvIXlLajhEUutqlZI6hHyBBPryy5Kh0zO4LAl3O4773JJg16zo97OFjcUgLMPfQOxeoqD4R9aa0bKwQ0ruLBg1Jx5G4S97gp/fuorM9NxqDKJXN3CmShl3Ax7ZgOKDg+xWipULk0V/485PRIz4x5BA3tq6VTcAV2Z3Hq3xspf6PVtvAKfyFtLSXWLMNeG/xNNpKZ1LKwmdN2tpwt8rQ3S7T9do8uuKw95fRrlt7SivrFVm5qQOO+nf3jFHtH9UOcV7oa35l1iz4BSThKL8VJ/RUAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon03.png
// module id = IXv1
// module chunks = 0